import type { FC } from "react";
import React from "react";
import styles from "./LegalBannerDisclaimer.module.scss";
import type {
    LegalBannerDisclaimerDataType,
    LegalBannerDisclaimerPayloadType,
} from "../../shared-logic/types/FinanceTypes";
import { LegalBannerTableOrientation } from "../../shared-logic/types/FinanceTypes";
import { useCommonSelector } from "../../../common-deprecated/redux/commonStore";
import useClientSideRender from "../../../common-deprecated/hooks/useClientSideRender";

const LegalBannerDisclaimer: FC<{
    data: LegalBannerDisclaimerDataType | null;
    isPdf?: boolean;
}> = ({ data, isPdf }) => {
    const settings = useCommonSelector((state) => state.commonSettings.legalBanner);
    const isClient = useClientSideRender();

    if (!data || !settings) return null;

    const payload: LegalBannerDisclaimerPayloadType = {
        title: settings?.title || "",
        dictionary: settings?.finance || {},
        finance: {
            image: settings?.image || {},
            finance: data.finance,
            text: data.disclaimer,
        },
        tableOrientation: data.tableOrientation,
    };

    const finance = JSON.stringify(payload.finance);

    return (
        <div className={styles.disclaimer}>
            {/* 
                COMPONENT IMPLEMENTATION IN ACCORDANCE WITH dxp-reference-guide #functional.mdx 
                Only render client-side to avoid hydration issues
            */}
            {isClient || isPdf ? (
                <dxp-foundation-components
                    key={finance} // Force re-render using a key
                    data-component="legalBanner"
                    data-title={payload.title}
                    data-finance={finance}
                    data-table-orientation={LegalBannerTableOrientation.horizontal}
                />
            ) : null}
        </div>
    );
};

export default LegalBannerDisclaimer;
